import { render, staticRenderFns } from "./assessmentdetail.vue?vue&type=template&id=1e254a8f"
import script from "./assessmentdetail.vue?vue&type=script&lang=js"
export * from "./assessmentdetail.vue?vue&type=script&lang=js"
import style0 from "./assessmentdetail.vue?vue&type=style&index=0&id=1e254a8f&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e254a8f')) {
      api.createRecord('1e254a8f', component.options)
    } else {
      api.reload('1e254a8f', component.options)
    }
    module.hot.accept("./assessmentdetail.vue?vue&type=template&id=1e254a8f", function () {
      api.rerender('1e254a8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giveLesson/assessmentdetail.vue"
export default component.exports